/* Copyright 2024 Marimo. All rights reserved. */

export function isIslands() {
  return import.meta.env.VITE_MARIMO_ISLANDS === "true";
}
